import React from 'react';

const TimeBoundNotification = () => {
  return (
    <div className="create-job-posting__tooltip-section" data-testid="pro-tip-timebound-notification">
      <div className="create-job-posting__notification">
        <p>
          All postings should align to local and state employment laws.
        </p>
      </div>
    </div>
  );
};

export default TimeBoundNotification;
